import { render, staticRenderFns } from "./TwoFactorAuthComponent.vue?vue&type=template&id=d4cc475e"
import script from "./TwoFactorAuthComponent.vue?vue&type=script&lang=js"
export * from "./TwoFactorAuthComponent.vue?vue&type=script&lang=js"
import style0 from "./TwoFactorAuthComponent.vue?vue&type=style&index=0&id=d4cc475e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports